import { render } from "./MenuDestinationItem.vue?vue&type=template&id=04b0cc38&scoped=true"
import script from "./MenuDestinationItem.vue?vue&type=script&lang=js"
export * from "./MenuDestinationItem.vue?vue&type=script&lang=js"

import "./MenuDestinationItem.vue?vue&type=style&index=0&id=04b0cc38&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/space-tourism-website-main-VueJs/cli-version/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b0cc38"]])

export default __exports__